import React, { useState, useEffect } from "react";
import "../../../entrydoor.css";
import "./WinColor.css";
import { useFinishData } from "./useFinishData";

const WinColorFull = ({ controlId, value = {}, onChange, label = "Win Color", color = null, dividers = null, disabled = false, colorType = "external", appliesTo = "windows" }) => {
  const [selectedWinColorFull, setSelectedWinColorFull] = useState(value);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isControlVisible, setIsControlVisible] = useState(true);

  const { loading, error, getFrameInternalColors, getFrameExternalColors } = useFinishData(appliesTo);

  // Get options based on colorType prop
  const options = colorType === "internal" ? getFrameInternalColors() : getFrameExternalColors();

  useEffect(() => {
    setSelectedWinColorFull(value);
  }, [value]);

  const handleSelect = (option) => {
    setSelectedWinColorFull(option);
    onChange(option); // Return the full { value, label } object
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(prev => !prev);
  };

  const handleBlur = () => {
    setTimeout(() => setIsDropdownOpen(false), 100);
  };

  useEffect(() => {
   /* if (color === 'Win') setIsControlVisible(true);
    else setIsControlVisible(false);

    if (dividers === 'None') setIsControlVisible(false);*/
  }, [color, dividers]);

  useEffect(() => {
    if (value?.value && value?.label) {
      setSelectedWinColorFull(value);
    }
  }, [value]);

  if (loading) {
    return (
      <div className="a-container">
        <label htmlFor="WinColorFull">{label}</label>
        <div className="custom-dropdown">
          <div className="dropdown-header" style={{ cursor: "wait" }}>
            <span>Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    console.error('Failed to load finish colors:', error);
  }

  return (
    <div className="a-container">
      {isControlVisible && (
        <>
          <label htmlFor="WinColorFull">{label}</label>
          <div
            className="custom-dropdown"
            style={{ zIndex: isDropdownOpen ? 1000 + controlId : 1 }}
          >
            <div
              className="dropdown-header"
              onClick={disabled ? null : toggleDropdown}
              onBlur={disabled ? null : handleBlur}
              style={{ cursor: "pointer" }}
              tabIndex={disabled ? -1 : 0}
            >
              <div
                className="color-circle"
                style={{
                  backgroundColor:
                    selectedWinColorFull?.value || "transparent",
                }}
              />
              <span>{selectedWinColorFull?.label || "Select an option"}</span>
            </div>

            {isDropdownOpen && (
              <div className="dropdown-options">
                {options.map((option, index) => (
                  <div
                    key={`${option.value}-${index}`}
                    className="dropdown-option"
                    onMouseDown={disabled ? null : () => handleSelect(option)}
                  >
                    <div
                      className="color-circle"
                      style={{ backgroundColor: option.color }}
                    />
                    <span>{option.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default WinColorFull;
